document.addEventListener("DOMContentLoaded", () => {
  const heroCollections = document.querySelector(".collections-hero");

  if (heroCollections) {
    const desktopImg = heroCollections.dataset.imgDesktop;
    const mobileImg = heroCollections.dataset.imgMobile;

    const applyHeroImage = () => {
      const isMobile = window.innerWidth <= 900;
      const currentImg = isMobile ? mobileImg : desktopImg;
      if (currentImg) {
        heroCollections.style.backgroundImage = `url("${currentImg}")`;
      }
    };

    applyHeroImage();
    window.addEventListener("resize", applyHeroImage);
  }

  // const rows = document.querySelectorAll(".project-table__row");
  // const preview = document.getElementById("collection-preview");

  // if (!rows.length || !preview) return;

  // const defaultRow = rows[0];
  // const defaultImage = defaultRow.dataset.image;

  // const setPreviewImage = (url) => {
  //   if (url) {
  //     preview.style.backgroundImage = `url(${url})`;
  //     preview.classList.add("has-image");
  //   } else {
  //     preview.style.backgroundImage = "";
  //     preview.classList.remove("has-image");
  //   }
  // };

  // defaultRow.classList.add("is-active");
  // setPreviewImage(defaultImage);

  // rows.forEach((row) => {
  //   row.addEventListener("mouseenter", () => {
  //     rows.forEach((r) => r.classList.remove("is-active"));
  //     row.classList.add("is-active");

  //     const imageUrl = row.dataset.image;
  //     setPreviewImage(imageUrl);
  //   });

  //   row.addEventListener("mouseleave", () => {
  //     rows.forEach((r) => r.classList.remove("is-active"));
  //     defaultRow.classList.add("is-active");
  //     setPreviewImage(defaultImage);
  //   });

  //   row.addEventListener("click", () => {
  //     const url = row.dataset.url;
  //     if (url) {
  //       window.location.href = url;
  //     }
  //   });
  // });

  const rows = document.querySelectorAll(".project-table__row");
  const previewImg = document.getElementById("collection-preview-img");

  if (!rows.length || !previewImg) return;

  const defaultRow = rows[0];
  const defaultImage = defaultRow.dataset.image;

  const setPreviewImage = (url) => {
    if (url) {
      previewImg.src = url;
      previewImg.classList.add("has-image");
    } else {
      previewImg.src = "";
      previewImg.classList.remove("has-image");
    }
  };

  defaultRow.classList.add("is-active");
  setPreviewImage(defaultImage);

  rows.forEach((row) => {
    row.addEventListener("mouseenter", () => {
      rows.forEach((r) => r.classList.remove("is-active"));
      row.classList.add("is-active");
      const imageUrl = row.dataset.image;
      setPreviewImage(imageUrl);
    });

    row.addEventListener("mouseleave", () => {
      rows.forEach((r) => r.classList.remove("is-active"));
      defaultRow.classList.add("is-active");
      setPreviewImage(defaultImage);
    });

    row.addEventListener("click", () => {
      const url = row.dataset.url;
      if (url) {
        window.location.href = url;
      }
    });
  });
});
